export const BASE_URL = "https://api.roi-ace.leveldata.com/api/"
export const HOST = "https://roi.leveldata.com/"
export const PENDO_API_KEY = "7eb8ffce-9b22-4cba-4472-6bec3a14f844"